/** When unset, follow the page origin so LAN IP / phone access works behind Traefik. */
function defaultOrigin(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://mopion.ca';
}

/** Base URL for JSON API calls (includes `/api`). */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? `${defaultOrigin()}/api`;

/** Origin of the backend (no path), used for OAuth start URL. */
export const API_ORIGIN =
  import.meta.env.VITE_API_ORIGIN ?? defaultOrigin();

export const GOOGLE_OAUTH_URL = `${API_ORIGIN.replace(/\/$/, '')}/oauth2/authorization/google`;

export const STORAGE_ACCESS = 'mopion_access_token';
export const STORAGE_REFRESH = 'mopion_refresh_token';
